import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, } from 'react';
import { getInitials } from '@zurich-client/typeutils/general';
import { font } from '../../styles';
import { styled } from '../../utils';
import { Avatar } from '../Avatar';
import { Menu, MenuItem } from '../Menu';
// TODO:  Wait for the final Design. Should be more generic. Most of the componet will be not used in Kundeportal.
export function TopNavigation({ userName, menuItems, LogoComponent, SearchBarComponent, }) {
    const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
    const initials = getInitials(userName);
    const handleOpenUserMenu = (e) => {
        setUserMenuAnchorEl(e.currentTarget);
    };
    const handleUserMenuClose = () => {
        setUserMenuAnchorEl(null);
    };
    return (_jsxs(HeaderWrapperStyled, { children: [LogoComponent, SearchBarComponent && (_jsx(SearchBarStyled, { children: SearchBarComponent })), userName && (_jsxs(ActionBarStyled, { children: [_jsx(Avatar, { size: "m", initials: initials, onClick: handleOpenUserMenu }), _jsx(Menu, { anchorEl: userMenuAnchorEl, keepMounted: true, open: userMenuAnchorEl !== null, onClose: handleUserMenuClose, children: menuItems?.map(({ key, text, onClick }) => (_jsx(UserMenuItemStyled, { onClick: (e) => {
                                setUserMenuAnchorEl(null);
                                onClick(e, key);
                            }, value: "", children: text }, key))) })] }))] }));
}
const HeaderWrapperStyled = styled('div')(({ theme }) => ({
    height: theme.spacing(8.25),
    padding: theme.spacing(2),
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    zIndex: 5,
    borderBottom: `1px solid ${theme.palette.groupPrimary.lightDove}`,
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.primary.contrastText,
}));
const SearchBarStyled = styled('div')({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
});
const ActionBarStyled = styled('div')({
    display: 'flex',
    marginLeft: 'auto',
    zIndex: 2, // because badge ovelaps the paper
    cursor: 'pointer',
});
const UserMenuItemStyled = styled(MenuItem)({
    fontSize: font.size.s,
});
